module.exports = __webpack_public_path__ + "43b08f66012f440ec4afc4687d3b40f4.MP3";